module.exports = __webpack_public_path__ + "img/swsjp-ico.bb314de9.png";